import { _GetSelectedProduct, type ProductStoreStockViewModel } from 'autogen/swagger/all';
import { formatReact } from 'modules/helpers/strings';
import StatusItem from 'components/StatusItem';
import styled from 'styled-components';
import StoreStockInfo from '../StockInfoItem';
import { useFindInStoreWithStoreStockQuickView } from 'components/storeList/shared/hooks';
import { GA4Tracking } from 'modules/tracking/GA4';
import { FakeButton } from 'components/StockInfo/shared/styles';
import { useGetProductStoreStockModelQuery } from 'autogen/swagger/all/hooks';
import { useProductPageExpectedDeliveryQuickView } from 'components/expecteddelivery/shared/hooks/useProductPageExpectedDeliveryQuickView';
import { useIsChanel } from 'hooks/user/useIsBrand';

type StoreStockInfoRendererProps = {
    model: ProductStoreStockViewModel;
    productId: number;
};

const Info = styled.div`
    grid-area: info;
`;

export default function StoreStockInfoRenderer(props: StoreStockInfoRendererProps) {
    const { model: initialModelProductStoreStockModel, productId } = props;
    const [, toggle] = useFindInStoreWithStoreStockQuickView();
    const toggleExpextedDelivery = useProductPageExpectedDeliveryQuickView();
    const { request: initialRequest } = initialModelProductStoreStockModel;
    const { data: productStoreStockModel } = useGetProductStoreStockModelQuery(initialRequest, {
        initialData: initialModelProductStoreStockModel,
        enabled: false
    });
    const { heading, text, buttonText, state } = productStoreStockModel || initialModelProductStoreStockModel;
    const isChanel = useIsChanel();

    async function toggleFindInStoreQuickView() {
        await _GetSelectedProduct({ productId }).then((data) => {
            toggle({
                isOpen: true,
                productId,
                productInfo: data,
                showClickAndCollectToggle: true,
                storeStockModel: productStoreStockModel || initialModelProductStoreStockModel,
                showSelectParcelShop: true
            });
        });

        GA4Tracking({
            eventName: 'find_in_store',
            category: 'ecommerce',
            context: 'product_page'
        });
    }

    async function toggleDeliveryInfo() {
        toggleExpextedDelivery(true);

        GA4Tracking({
            eventName: 'open_modal',
            category: 'ecommerce',
            context: 'product_page',
            eventParams: [{ param_name: 'modal_type', param_value: 'delivery_info' }]
        });
    }

    switch (state) {
        case 'OnlineOnly':
            return (
                <StoreStockInfo
                    iconType="Store"
                    heading={heading}
                    {...(text ? { onClick: toggleDeliveryInfo, infoRenderer: () => <Info>{text}</Info> } : {})}
                    showArrow={!!text}
                />
            );
        case 'FindInStore':
            return (
                <StoreStockInfo
                    iconType="Store"
                    heading={heading}
                    onClick={toggleFindInStoreQuickView}
                    infoRenderer={() => (
                        <Info>
                            <StatusItem color={isChanel ? 'Black' : 'Green'} bulletSize={10}>
                                {formatReact(text)(<FakeButton>{buttonText}</FakeButton>)}
                            </StatusItem>
                        </Info>
                    )}
                />
            );
        case 'FulfillmentFromStore':
            return (
                <StoreStockInfo
                    iconType="Store"
                    heading={heading}
                    onClick={toggleDeliveryInfo}
                    infoRenderer={() => <Info>{text}</Info>}
                />
            );
        case 'ClickAndCollect':
            return (
                <StoreStockInfo
                    iconType="Store"
                    heading={heading}
                    onClick={toggleFindInStoreQuickView}
                    infoRenderer={() => (
                        <Info>
                            <StatusItem color={isChanel ? 'Black' : 'Green'} bulletSize={10}>
                                {formatReact(text)(<FakeButton>{buttonText}</FakeButton>)}
                            </StatusItem>
                        </Info>
                    )}
                />
            );
        case 'SoldOut':
            return <StoreStockInfo iconType="Store" heading={heading} showArrow={false} />;
        default:
            return null;
    }
}
